import { createActions } from "../../helpers/utils/createActions";
import { FILTER_BAR } from "./actionTypes";

export const getFilterData = createActions(FILTER_BAR.GET_FILTER_DATA);
